<template>
  <div class="trip-request">
    <TripRequestPageHeading
      @filterData="filterData"
      pageName="trip-request"
      :filterOptions="[
        { name: 'Global Search', value: 'global_search' },
        { name: 'Status', value: 'status' }
      ]"
    ></TripRequestPageHeading>
    <div class="card text-center mt-3" style="margin-bottom: 100px">
      <div class="card-body">
        <DefaultLoader v-if="isLoading"></DefaultLoader>
        <template v-else-if="this.trips.length > 0">
          <div class="row">
            <div class="col-md-12">
              <select
                v-model="perPage"
                class="form-select form-select-sm"
                style="width: 90px"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
          <div class="mt-3">
            <div class="table-responsive">
              <table class="table table-hover table-bordered" id="datatable">
                <thead class="table-light">
                  <tr>
                    <th>SL</th>
                    <th>Unique Id</th>
                    <th>Route</th>
                    <th>Parent Route</th>
                    <th>Trip Start Date</th>
                    <th>Distance</th>
                    <th>Status</th>
                    <th>Service Type</th>
                    <th>Invited</th>
                    <th>Interested</th>
                    <th>Confirmed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(trip, index) in trips"
                    :key="trip.id"
                    @click="goToDetailsPage(trip.id)"
                  >
                    <td>
                      {{ perPage * (currentPage - 1) + index + 1 }}
                      <!--                        <router-link :to="`/trip/details/${trip.id}`"-->
                      <!--                          >{{ perPage * (currentPage - 1) + index + 1 }}-->
                      <!--                        </router-link>-->
                    </td>
                    <td>
                      <router-link :to="`/trip-request/trip/details/${trip.id}`"
                        >{{ trip.trip_code }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="`/trip-request/trip/details/${trip.id}`"
                        >{{ trip.route_name }}
                      </router-link>
                    </td>
                    <td>{{ trip.parent_route_name }}</td>
                    <td>{{ trip.trip_start_date }}</td>
                    <td>{{ trip.distance }}</td>
                    <td>{{ trip.status }}</td>
                    <td>{{ trip.serviceType }}</td>
                    <td>{{ trip.invited }}</td>
                    <td>{{ trip.interested }}</td>
                    <td>{{ trip.confirmed }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Paginate -->
          <div class="row">
            <div class="col-md-12">
              <p style="float: left">
                Showing {{ this.from }}-{{ this.to }} out of {{ this.total }}
              </p>
              <paginate
                :totalPages="totalPages"
                :total="total"
                :currentPage="currentPage"
                :perPage="perPage"
                v-on:pagechanged="getAllData"
              ></paginate>
            </div>
          </div>
        </template>
        <NoDataMessage v-else></NoDataMessage>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from '../pagination/Pagination.vue';
import http from '../../config/axios';
// import Loader from '../../components/lib/Loader';
import TripRequestPageHeading from './TripRequestPageHeading.vue';

export default {
  name: 'RequestedTrip',
  props: ['swal'],
  components: {
    Paginate,
    // Loader,
    TripRequestPageHeading
  },
  mounted() {
    this.getAllData();
    // this.searchData();
    this.permission = localStorage.getItem('userPermission').split(',');
  },
  data() {
    return {
      trips: [],
      totalPages: 0,
      total: 0,
      currentPage: 1,
      perPage: 10,
      pageCount: '',
      to: 0,
      from: 0,
      global_search: '',
      service_type: '',
      isLoading: true,
      trip_request_status: '',
      permission: '',
      filterValues: {
        global_search: '',
        status: '',
        service_type: ''
      }
    };
  },
  watch: {
    perPage: function () {
      this.getAllData();
    }
    // 'filterValues.service_type': function () {
    //   this.getAllData();
    // }
  },
  methods: {
    getAllData(value) {
      this.isLoading = true;
      http
        .get(
          `v2/partners/triprequests?status=${this.filterValues.status}&global_search=${this.filterValues.global_search}
          &page=${value}&service_type=${this.filterValues.service_type}&per_page=${this.perPage}`
        )
        .then((response) => {
          this.trips = response.data.data.data;
          this.total = response.data.data.total;
          this.totalPages = response.data.data.last_page;
          this.currentPage = response.data.data.current_page;
          this.perPage = response.data.data.per_page;
          this.to = response.data.data.to;
          this.from = response.data.data.from;
          this.isLoading = false;
        });
    },
    // filter(e, value) {
    //   this.isLoading = true;
    //   this.pageCount = value;
    //   this.trip_request_status = e.target.value;
    //   http
    //     .get(
    //       `v2/partners/triprequests?status=${e.target.value}&global_search=${
    //         this.global_search ? this.global_search : ''
    //       }&page=${value}`
    //     )
    //     .then((response) => {
    //       this.trips = response.data.data.data;
    //       this.total = response.data.data.total;
    //       this.totalPages = response.data.data.last_page;
    //       this.currentPage = response.data.data.current_page;
    //       this.perPage = response.data.data.per_page;
    //       this.to = response.data.data.to;
    //       this.from = response.data.data.from;
    //       this.isLoading = false;
    //     });
    // },
    tripStatusChange(e, id) {
      this.swal({
        title: 'Are you sure?',
        text: 'You want to change the status of this trip?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, change it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          http
            .put('v2/partners/triprequests/status/' + id, {
              status: e.target.value
            })
            .then(() => {
              this.getAllData();
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (result.dismiss === this.swal.DismissReason.cancel) {
          this.getAllData();
        }
      });
    },
    // searchData() {
    //   this.isLoading = true;
    //   this.getAllData();
    // },
    goToDetailsPage(tripId) {
      this.$router.push(`/trip-request/trip/details/${tripId}`);
    },
    filterData(filterValues) {
      this.filterValues.global_search = filterValues.global_search;
      this.filterValues.status = filterValues.status;
      this.filterValues.service_type = filterValues.service_type;
      this.getAllData();
    }
  }
};
</script>

<style scoped>
.table {
  font-size: 13px;
  font-style: normal;
}

.table thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #f8f9fa;
  background: #f3f3f3;
}

#searchButton {
  background: #1c2457;
}

#searchButton:hover,
#searchButton:focus,
#searchButton:active {
  background: #1c2457;
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .dataTables_filter,
  .dataTables_info {
    display: none;
  }

  .filter-style {
    text-align: center;
  }

  .dropdown {
    text-align: end;
  }
}
</style>
